module.exports = __webpack_public_path__ + "static/media/web_background.12c280ca.svg";